import React, { useState, useEffect } from 'react';
import { Cascader } from 'antd';
import Axios from 'axios';

export const DatasetCascaderSelect = (props) => {
    const [value, setValue] = useState(undefined);
    const [treeData, setTreeData] = useState([]);

    const listToTreeByParentId = (list) => {
        var map = {}, node, roots = [], i;

        for (i = 0; i < list.length; i += 1) {
            map[list[i].id] = i;
            list[i].children = [];
        }

        for (i = 0; i < list.length; i += 1) {
            node = list[i];
            if (node.parentId !== null) {
                list[map[node.parentId]].children.push(node);
            } else {
                roots.push(node);
            }
        }
        return roots;
    }

    const fetchData = async () => {
        try {
            let response = await Axios.post(`${process.env.REACT_APP_API_BASE_URI}/api/find/${props.connector}/${props.dataset}`, props.filters ? props.filters : {});
            setTreeData(listToTreeByParentId(response.data))
            return response.data;
        } catch (err) {
            console.log(err);
        }
    };

    const fetchAll = async () => {
        await fetchData();
    }

    useEffect(() => {
        fetchAll();
    }, []);

    const onChange = value => {
        console.log(value);
        setValue(value);
    };

    return (
        <Cascader
            allowClear
            changeOnSelect 
            options={treeData}
            value={value}
            onChange={onChange}
            placeholder="Please select"
            {...props}
        />
    );
};